// Single source of truth for the site name. Do not change per prompt or per version.
export const SITE_NAME = 'Hondurans in LA';
export const SITE_DESCRIPTION =
  'Hondurans In LA is a community-driven movement celebrating Honduran culture and creating opportunity across Los Angeles.';
